import type { DashboardWidgetKey } from "@repo/shared/types";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { ActionItemsWidget } from "./action-items-widget";
import { ActivitiesWidget } from "./activities-widget";
import { AdviceToCheckWidget } from "./advice-to-check-widget";
import { ApprovalsWaitingWidget } from "./approvals-waiting-widget";
import { CashToInvestWidget } from "./cash-to-invest-widget";
import { ClientsWidget } from "./clients-widget";
import { CompletedThisMonthWidget } from "./completed-this-month-widget";
import { FlowsWidget } from "./flows-widget";
import { IdentityChangesWidget } from "./identity-changes-widget";
import { NextMeetingsWidget } from "./next-meetings-widget";
import { PendingSignaturesWidget } from "./pending-signatures-widget";
import { PipelineWidget } from "./pipeline-widget";
import { RecentActivityWidget } from "./recent-activity-widget";
import { ReviewStatusWidget } from "./review-status-widget";
import { SavingInflowWidget } from "./saving-inflow-widget";
import { ScreeningWidget } from "./screening-widget";
import { SignaturesExpiringWidget } from "./signatures-expiring-widget";
import { TotalAumWidget } from "./total-aum-widget";
import { UsersWidget } from "./users-widget";
import { VerifiedIdWidget } from "./verified-id-widget";

type DashboardWidgetProps = {
  widgetKey: DashboardWidgetKey;
  target: DashboardTarget;
  userHref: (userId: string) => string;
};

/** One widget by its key. */
export function DashboardWidget({ widgetKey, target, userHref }: DashboardWidgetProps) {
  switch (widgetKey) {
    case "clients":
      return <ClientsWidget target={target} />;
    case "total_aum":
      return <TotalAumWidget target={target} />;
    case "saving_inflow":
      return <SavingInflowWidget target={target} />;
    case "activities":
      return <ActivitiesWidget target={target} />;
    case "flows":
      return <FlowsWidget target={target} />;
    case "completed_this_month":
      return <CompletedThisMonthWidget target={target} />;
    case "pending_signatures":
      return <PendingSignaturesWidget target={target} />;
    case "users":
      return <UsersWidget target={target} userHref={userHref} />;
    case "pipeline":
      return <PipelineWidget target={target} />;
    case "next_meetings":
      return <NextMeetingsWidget target={target} />;
    case "action_items":
      return <ActionItemsWidget target={target} />;
    case "recent_activity":
      return <RecentActivityWidget target={target} />;
    case "signatures_expiring":
      return <SignaturesExpiringWidget target={target} />;
    case "cash_to_invest":
      return <CashToInvestWidget target={target} />;
    case "approvals_waiting":
      return <ApprovalsWaitingWidget target={target} />;
    case "review_status":
      return <ReviewStatusWidget target={target} />;
    case "advice_to_check":
      return <AdviceToCheckWidget target={target} />;
    case "screening":
      return <ScreeningWidget target={target} />;
    case "verified_id":
      return <VerifiedIdWidget target={target} />;
    case "identity_changes":
      return <IdentityChangesWidget target={target} />;
  }
}
